import { useState } from "react";

import MainButton from "~/components/common/mainButton";
import Modal from "~/components/ui/modal";
import { useLanguage } from "~/contexts/providers/language";

import styles from "./index.module.scss";

const translations = {
  Fr: {
    confirm: "Confirmer",
    cancel: "Annuler",
    areYouSure: "Souhaitez-vous vraiment vous désinscrire de cet évènement ?",
  },
  En: {
    confirm: "Confirm",
    cancel: "Cancel",
    areYouSure: "Do you want to cancel your attendance to this event ? ",
  },
};

type Props = {
  handleCancelEvent: () => void;
  cancelIsLoading: boolean;
};

const CancelEventAttendance = ({
  handleCancelEvent,
  cancelIsLoading,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const { language: lang } = useLanguage();

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <MainButton
        theme="transparent-grey"
        onClick={handleOpenModal}
        // isLoading={cancelIsLoading}
      >
        {lang === "Fr" ? "Annuler" : "Cancel"}
      </MainButton>

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div className={styles.container}>
          <p>{translations[lang].areYouSure}</p>
          <br />
          <div className={styles.buttons}>
            <MainButton disabled={cancelIsLoading} onClick={handleCloseModal}>
              {translations[lang].cancel}
            </MainButton>
            &nbsp;&nbsp;
            <MainButton onClick={handleCancelEvent} isLoading={cancelIsLoading}>
              {translations[lang].confirm}
            </MainButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CancelEventAttendance;
